import { RecommendationService } from '../services'
import Vue from 'vue'

export const state = {
    recommendations: {},
    selectedForRecommendation: {},
    recommendableKarenVenuesForListView: {
        eventCityVenues: [],
        otherVenues: []
    },
    recommendableKarenVenuesForMapView: {},
    scoringSettings: [],
    quickRecommendations: {},
    aiAgentSuggestedVenues: []
}

export const actions = {
    getRecommendations({ dispatch, commit, getters }, leadEventId) {
        return RecommendationService.getRecommendations(leadEventId)
            .then(recommendations => {
                recommendations = recommendations.data;
                commit('UpdateLeadEventRecommendations', {
                    recommendations,
                    leadEventId
                })
            })
            .catch(error => {
                dispatch('alert/error', error, { root: true })
            })
    },
    getQuickRecommendations ({ state, commit, dispatch }) {
        if (state.quickRecommendations.length) {
            return Promise.resolve(state.quickRecommendations)
        }

        return RecommendationService.getQuickRecommendations()
            .then(results => {
                commit('updateQuickRecommendations', results.data)
                return results.data
            })
            .catch(error => {
                dispatch('alert/error', error, { root: true })
            })
    },
    sendRecommendation({ dispatch }, data) {
        let successMessage = 'Recommendation email sent successfully.';
        if (data.doNotSendEmail) {
            successMessage = 'Recommendations saved successfully.'
        }

        return RecommendationService.sendRecommendation(
            data.leadEventId,
            data.venues,
            data.template,
            data.subject,
            data.portalLink,
            data.sendAsQuickRecommend || false,
            data.doNotSendEmail || false
        ).then(response => {
            if (response?.data?.success === true) {
                dispatch('alert/success', successMessage, {
                    root: true
                })
            } else {
                dispatch(
                    'alert/error',
                    'An error occurred while sending the email.',
                    { root: true }
                )
            }
        })
        .catch(error => {
            dispatch('alert/error', error, { root: true })
        })
    }
}
export const mutations = {
    updateScoringSettings(state, settings) {
        state.scoringSettings = settings;
    },
    updateKarenVenuesForListView(state, venueRooms) {
        state.recommendableKarenVenuesForListView.eventCityVenues = venueRooms['eventCityVenues'] ?? [];
        state.recommendableKarenVenuesForListView.otherVenues = venueRooms['otherVenues'] ?? [];

    },
    updateKarenVenuesForMapView(state, venueRooms) {
        state.recommendableKarenVenuesForMapView = venueRooms;
    },
    UpdateLeadEventRecommendations(state, data) {
        Vue.set(state.recommendations, data.leadEventId, data.recommendations);
    },
    updateSelectedForRecommendation(state, {leadEventId, rooms}) {
        if (! leadEventId || ! rooms) {
            return;
        }

        Vue.set(state.selectedForRecommendation, leadEventId, rooms);
    },
	updateQuickRecommendations (state, data) {
		state.quickRecommendations = data;
	},
    updateAiAgentSuggestedVenues(state, data) {
        state.aiAgentSuggestedVenues = data;
    }
}
export const getters = {
    getRecommendationsByLeadEventId: state => leadEventId => {
        return state.recommendations[leadEventId] ?? [];
    },
    getSelectedVenueRoomsForRecommendation: state => leadEventId => {
        return state.selectedForRecommendation[leadEventId] ?? [];
    },
    getKarenVenuesForListView: state => locationType => {
        if (! ['all', 'eventCityVenues', 'otherVenues'].includes(locationType)) {
            return [];
        }

        if (locationType == 'all') {
            return state.recommendableKarenVenuesForListView;
        } else {
            return state.recommendableKarenVenuesForListView['locationType'] ?? [];
        }
    },
    getKarenVenuesForMapView: state => () => {
        return state.recommendableKarenVenuesForMapView
    },
    getKarenScoringSettings: state => state.scoringSettings,
	getQuickRecommendations: state => state.quickRecommendations,
    getAiAgentSuggestedVenues: state => state.aiAgentSuggestedVenues
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
